export enum PLATFORM_TYPE {
  WEB = 'web'
}
